import React, { memo, useMemo } from 'react';
import MenuList from './MenuList';
import MenuItem from './MenuItem';
import RouteAuthentication from '../../../routeAuth';
import { useLocation } from 'react-router-dom';

const Menu = () => {
    const { pathname } = useLocation();

    // Chỉ lấy segment gốc của pathname (vd: '/so-sach-ban-tru/agency' → '/so-sach-ban-tru')
    // Menu chỉ cần tính lại khi chuyển module, không phải mỗi lần đổi route con
    const modulePath = useMemo(() => {
        if (!pathname) return '/so-sach-ban-tru';
        const segments = pathname.split('/').filter(Boolean);
        return segments.length > 0 ? `/${segments[0]}` : '/so-sach-ban-tru';
    }, [pathname]);

    const menus = useMemo(() => {
        if (!modulePath) return [];

        const modules = RouteAuthentication.getModule();
        const currentModule = modules.find(
            (m) => (m.path || m.link) === modulePath,
        );

        if (!currentModule) return [];

        return RouteAuthentication.getMenuByModule(currentModule.path);
    }, [modulePath]);

    return (
        <MenuList>
            {menus.map((item) => (
                <MenuItem key={item.path || item.link} menu={item} />
            ))}
        </MenuList>
    );
};

export default memo(Menu);
